module.exports = __webpack_public_path__ + "img/1f912.b3aae17.svg";